import React from 'react';
import { Box, Typography } from '@mui/material';
import data from './data.json';
// import Copyright from 'components/CopyRight';

const Privacy = () => {
  return (
    <Box sx={{my: 2, mb: '51px'}}>
      <Typography variant="h4" component="h1" color="secondary" align="center">
        Privacy Policy
      </Typography>
      <Box sx={{mt: 2}}>
        <Typography variant="body2">
          This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. PII, as described in privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.
        </Typography>
      </Box>
      {data.map(({heading, description}, i) => (
        <Box sx={{mt: 2.2}} key={i}>
          <Typography variant="subtitle2" component="h2" color="secondary"
            dangerouslySetInnerHTML={{
              __html: heading
            }}
          />
          {description.map((text, j) => (
            <Typography variant="body2"  key={j}
              dangerouslySetInnerHTML={{
                __html: text
              }}
            />
          ))}
        </Box>
      ))}
      {/* <Copyright /> */}
    </Box>
  );
}
 
export default Privacy;
